import createReactClass from "create-react-class";

export default ({ tools, language, makeErrors }) => {

    const html = createReactClass({

        render() {
            const { field, errorClass } = this.props;
            const { config, state } = field;
            const styleInput = { height: "100%" };

            const {
                id,
                label,
                tinyLabel,
                options,
                name,
            } = config;

            // loops through options and sets a radio button for each option
            const radioButtons = options.map(option => {
                const { value, display } = option;
                return (
                    <div className={`lz-input-wrapper ${errorClass}`} key={value}>
                        <div className="lz-radio">
                            <input
                                style={styleInput}
                                type="radio"
                                name={name}
                                id={value}
                                value={value}
                                onChange={this.onChange}
                            />

                            <label htmlFor={name}>
                                <div className="lz-table lz-table-middle">
                                    <div className="lz-table-cell">
                                        <span className="lz-radio-span" />
                                    </div>
                                    <div className="lz-table-cell">
                                        <em>{display}</em>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                );
            });

            return (
                <div className="lz-input-wrapper">
                    <label htmlFor={tools.uniqueId(id)}>{label}</label>
                    <span className="lz-extratext">{tinyLabel}</span>
                    {radioButtons}
                    {makeErrors(state.errors)}
                </div>
            );
        },

        onChange(event) {
            this.props.field.state.value = event.target.value;
            this.forceUpdate();
            this.props.onUpdate();
        },
    });

    return {
        html,
        validators: [
            state => {
                if (!state.value) return language.error_radio_button;
            }
        ]
    };
};